
import { defineComponent } from 'vue';

import Modal from './util/Modal.vue';

export default defineComponent({ components: { Modal } });
